import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-form-error-messages',
  standalone: true,
  templateUrl: './form-error-messages.component.html',
  styleUrls: ['./form-error-messages.component.scss'],
  imports: [
    CommonModule,
    TranslatePipe
  ],
})
export class FormErrorMessagesComponent implements OnInit {
  @Input() form: any = '';
  @Input() question: any = '';
  @Input() formGroup: any = '';
  @Input() submitted: any = '';

  constructor() {}

  ngOnInit(): void {}
}
